// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3078 ? "8627a13e" : chunkId) + "." + {"2420":"b28b2dbbc9ef469e","3078":"6cf27a7e22a8467a","3105":"94a12f835d989df6","5844":"cacfda1449b15020","7421":"cfe49717ff2ac923","8491":"d42a196a9e7795bd","8956":"dc8a62867c01f157"}[chunkId] + ".js";
};